module.exports = __webpack_public_path__ + "img/图片30.aa5b32a6.png";